import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }
const _hoisted_3 = { class: "mb-2 flex flex-wrap gap-1" }
const _hoisted_4 = { class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600" }
const _hoisted_5 = {
  key: 0,
  class: "rounded bg-catering-honey-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-honey-600"
}
const _hoisted_6 = {
  key: 1,
  class: "rounded bg-catering-berry-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-berry-600"
}
const _hoisted_7 = {
  key: 0,
  class: "overflow-x-auto"
}
const _hoisted_8 = { class: "w-full text-left text-xs" }
const _hoisted_9 = { class: "divide-y divide-catering-cream-300" }
const _hoisted_10 = { class: "text-catering-ink-800" }
const _hoisted_11 = { class: "py-1.5 pr-2" }
const _hoisted_12 = { class: "font-medium text-catering-ink-900" }
const _hoisted_13 = {
  key: 0,
  class: "ml-1 text-catering-ink-500"
}
const _hoisted_14 = {
  key: 1,
  class: "ml-1 text-catering-ink-500"
}
const _hoisted_15 = { class: "py-1.5 pr-2 text-right tabular-nums" }
const _hoisted_16 = {
  key: 0,
  class: "text-catering-ink-500"
}
const _hoisted_17 = {
  class: "pb-1.5 text-[11px]",
  colspan: "4"
}
const _hoisted_18 = {
  key: 0,
  class: "block"
}
const _hoisted_19 = {
  key: 1,
  class: "block font-medium text-catering-berry-600"
}
const _hoisted_20 = {
  key: 2,
  class: "block"
}
const _hoisted_21 = { class: "border-t border-catering-cream-300 text-catering-ink-900" }
const _hoisted_22 = { class: "py-1.5 text-right font-semibold tabular-nums" }
const _hoisted_23 = {
  key: 1,
  class: "text-catering-ink-500"
}
const _hoisted_24 = {
  key: 2,
  class: "mt-2 text-[11px] text-catering-ink-500"
}
const _hoisted_25 = { key: 0 }

import { computed } from 'vue'


export default {
  __name: 'BotLineItemBreakdown',
  props: { block: { type: Object, required: true } },
  setup(__props) {

const props = __props

const lines = computed(() => props.block.lines || [])
const autofill = computed(() => props.block.autofill || {})

function amountClass(line) {
  if (!line.pricing_ran) return 'text-catering-berry-600'
  if (line.zero_reason) return 'text-catering-honey-600'
  return 'text-catering-ink-700'
}

function detailFor(line) {
  return !line.pricing_ran || line.zero_explanation || line.included_quantity
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, " Line items · Order " + _toDisplayString(__props.block.order), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.block.line_count) + " " + _toDisplayString(__props.block.line_count === 1 ? 'line' : 'lines'), 1),
      (__props.block.zero_line_count)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.block.zero_line_count) + " " + _toDisplayString(__props.block.unpriced_line_count ? 'at $0 or unpriced' : 'at $0'), 1))
        : _createCommentVNode("", true),
      (__props.block.unpriced_line_count)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.block.unpriced_line_count) + " never priced ", 1))
        : _createCommentVNode("", true)
    ]),
    (lines.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
              _createElementVNode("tr", { class: "text-catering-ink-500" }, [
                _createElementVNode("th", { class: "py-1 pr-2 font-medium" }, "Item"),
                _createElementVNode("th", { class: "py-1 pr-2 text-right font-medium" }, "Qty"),
                _createElementVNode("th", { class: "py-1 pr-2 text-right font-medium" }, "Unit"),
                _createElementVNode("th", { class: "py-1 text-right font-medium" }, "Total")
              ])
            ], -1)),
            _createElementVNode("tbody", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lines.value, (l, i) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                  _createElementVNode("tr", _hoisted_10, [
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(l.product), 1),
                      (l.upsell)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "· upsell"))
                        : _createCommentVNode("", true),
                      (l.likely_autofilled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "· likely autofilled"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_15, _toDisplayString(l.quantity), 1),
                    _createElementVNode("td", {
                      class: _normalizeClass(["py-1.5 pr-2 text-right tabular-nums", amountClass(l)])
                    }, _toDisplayString(l.unit_price), 3),
                    _createElementVNode("td", {
                      class: _normalizeClass(["py-1.5 text-right tabular-nums", amountClass(l)])
                    }, _toDisplayString(l.line_total), 3)
                  ]),
                  (detailFor(l))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                        _createElementVNode("td", _hoisted_17, [
                          (l.included_quantity)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(l.included_quantity) + " of " + _toDisplayString(l.quantity) + " included in the meal plan ", 1))
                            : _createCommentVNode("", true),
                          (!l.pricing_ran)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, " Pricing never ran for this line — this is not a priced $0. "))
                            : _createCommentVNode("", true),
                          (l.zero_explanation)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(l.zero_explanation), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]),
            _createElementVNode("tfoot", null, [
              _createElementVNode("tr", _hoisted_21, [
                _cache[0] || (_cache[0] = _createElementVNode("td", {
                  class: "py-1.5 pr-2 font-semibold",
                  colspan: "3"
                }, "Line items subtotal", -1)),
                _createElementVNode("td", _hoisted_22, _toDisplayString(__props.block.line_items_subtotal), 1)
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("p", _hoisted_23, "This order has no line items to break down.")),
    (autofill.value.likely_autofilled_line_count)
      ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
          _createTextVNode(_toDisplayString(autofill.value.likely_autofilled_line_count) + " " + _toDisplayString(autofill.value.likely_autofilled_line_count === 1 ? 'line is' : 'lines are') + " likely autofilled. ", 1),
          (autofill.value.note)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(autofill.value.note), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.notes || [], (n, i) => {
      return (_openBlock(), _createElementBlock("p", {
        key: 'n' + i,
        class: "mt-2 text-[11px] text-catering-ink-500"
      }, _toDisplayString(n), 1))
    }), 128))
  ]))
}
}

}